<template>
  <dropdown :align="align" dropdown-class="w-screen max-w-xs bg-white border rounded">
    <button class="w-full btn btn-secondary" :class="buttonClass">
      <fa :icon="['far', buttonIcon]" class="mr-1" /> {{ buttonText }}
    </button>
    <div slot="dropdown">
      <div class="flex justify-between p-4 border-b rounded-t bg-gray-50" v-if="!hideButtons">
        <button class="btn btn-sm btn-secondary" @click="$emit('clear')">
          Clear
        </button>
        <button class="btn btn-sm btn-primary" v-submitting="loading" @click="$emit('apply')">
          Apply
        </button>
      </div>
      <div class="p-4 space-y-5">
        <slot />
      </div>
    </div>
  </dropdown>
</template>

<script>
export default {
  name: 'FilterDropdown',

  props: {
    align: {
      type: String,
      default: 'left'
    },

    loading: {
      type: Boolean
    },

    hideButtons: {
      type: Boolean,
      default: false
    },
    
    buttonClass: {
      type: String,
      default: 'btn-sm'
    },

    buttonText: {
      type: String,
      default: 'Filter'
    },

    buttonIcon: {
      type: String,
      default: 'filter'
    }
  }
}
</script>